import { scholarshipActionTypes } from 'src/store/actions';

const initialState = {};
const ViewScholarshipsReducer = (state = initialState, action) => {
  const { type, payload } = action || {};
  switch (type) {
    case scholarshipActionTypes.GET_ALL_SCHOLARSHIPS:
      return payload;
    default:
      return state;
  }
};

export default ViewScholarshipsReducer;
